import { SWRConfig } from 'swr'

/**
 * Eid API configuration context provider to provide defaults.
 */
const EidApiConfig = SWRConfig

export default EidApiConfig
